export enum Role {
  Admin = 'superadmin',
  salesManager = 'salesmanager',
  financeManager = 'financemanager',
  Buyer = 'buyer',
  Inspector = 'inspector'
}
